export default {
  FOOTER: `powered by`,
};
